// src/pages/Contact.js - Page de contact FirstArabic
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

function Contact() {
  const [formData, setFormData] = useState({
    nom: '',
    email: '',
    sujet: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Envoyer l'email via le backend
      const response = await fetch(`${process.env.REACT_APP_API_URL}/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        setSuccess(true);
        setFormData({ nom: '', email: '', sujet: '', message: '' });
      } else {
        throw new Error('Erreur lors de l\'envoi');
      }
    } catch (err) {
      setError('Une erreur est survenue. Veuillez réessayer ou nous contacter directement par email.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="legal-container">
      <div className="legal-card contact-card">
        <div className="legal-header">
          <h1>📧 Contactez-nous</h1>
          <p>Une question ? Un problème ? Nous sommes là pour vous aider.</p>
        </div>

        <div className="contact-content">
          {/* Informations de contact */}
          <div className="contact-info">
            <h2>Nos coordonnées</h2>
            
            <div className="contact-item">
              <span className="contact-icon">📧</span>
              <div>
                <strong>Email</strong>
                <a href="mailto:contact@firstarabic.com">contact@firstarabic.com</a>
              </div>
            </div>
            <div className="contact-item">
              <span className="contact-icon">📱</span>
              <div>
                <strong>WhatsApp</strong>
                <a href="https://wa.me/33601823048" target="_blank" rel="noopener noreferrer">+33 6 01 82 30 48</a>
              </div>
            </div>
            <div className="contact-item">
              <span className="contact-icon">📍</span>
              <div>
                <strong>Adresse</strong>
                <p>FirstArabic<br />113 boulevard de Strasbourg<br />76600 Le Havre, France</p>
              </div>
            </div>

            <div className="contact-item">
              <span className="contact-icon">⏰</span>
              <div>
                <strong>Horaires de support</strong>
                <p>Lundi - Vendredi : 9h - 18h<br />Réponse sous 24-48h</p>
              </div>
            </div>

            <div className="contact-social">
              <h3>Suivez-nous</h3>
              <div className="social-links">
                <a href="https://www.instagram.com/firstarabic.com_?igsh=MW42Y2NieWU5OGRrcg==" target="_blank" rel="noopener noreferrer">Instagram</a>
              </div>
            </div>
          </div>

          {/* Formulaire de contact */}
          <div className="contact-form-section">
            <h2>Envoyez-nous un message</h2>

            {success ? (
              <div className="success-message">
                <span className="success-icon">✅</span>
                <h3>Message envoyé !</h3>
                <p>Nous vous répondrons dans les plus brefs délais.</p>
                <button onClick={() => setSuccess(false)} className="btn-primary">
                  Envoyer un autre message
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="contact-form">
                {error && <div className="error-message">{error}</div>}

                <div className="form-group">
                  <label htmlFor="nom">Nom complet *</label>
                  <input
                    type="text"
                    id="nom"
                    name="nom"
                    value={formData.nom}
                    onChange={handleChange}
                    placeholder="Votre nom"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="votre@email.com"
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="sujet">Sujet *</label>
                  <select
                    id="sujet"
                    name="sujet"
                    value={formData.sujet}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Sélectionnez un sujet</option>
                    <option value="question">Question générale</option>
                    <option value="technique">Problème technique</option>
                    <option value="paiement">Question sur le paiement</option>
                    <option value="professeur">Devenir professeur</option>
                    <option value="partenariat">Partenariat</option>
                    <option value="autre">Autre</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Décrivez votre demande..."
                    rows="5"
                    required
                  />
                </div>

                <button type="submit" className="btn-submit" disabled={loading}>
                  {loading ? '⏳ Envoi en cours...' : '📤 Envoyer le message'}
                </button>
              </form>
            )}
          </div>
        </div>

        <div className="legal-footer">
          <Link to="/">← Retour à l'accueil</Link>
        </div>
      </div>
    </div>
  );
}

export default Contact;
